export default "__VITE_ASSET__kvR0yrdd__"